import { PROSPECTS_ROUTES, BUSINESS_PROSPECTS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import prospectsTypes from '../../constants/prospectsTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// 1 delete
const delete_prospect_request = () => {
  return {
    type: prospectsTypes.destroy.request
  }
}

const delete_prospect_success = (response) => {
  return {
    type: prospectsTypes.destroy.success,
    payload: response.data
  }
}

const delete_prospect_failure = (messages) => {
  return {
    type: prospectsTypes.destroy.failure,
    payload: messages
  }
}

const delete_prospect = (prospect_id, page=1, per_page=10, filters={}, sort="", order="", user_type = "user") => {
  let routes = PROSPECTS_ROUTES
  if (user_type === "b2b") {
    routes = BUSINESS_PROSPECTS_ROUTES
  }
  return function(dispatch) {
    // Before Request
    dispatch( delete_prospect_request() )
    const reqParams = {
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      serial: current_timestamp(),
      filters: filters
    }
    // Request
    axios.delete(
      formatRoute(routes.destroy, {id: prospect_id}),
      {
        params: reqParams
      }
    ).then( response => {
      window.showSnackbar('success', 'The prospect has been deleted.')
      dispatch( delete_prospect_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [error]
      }
      window.showSnackbar('error', "STOP!")
      dispatch( delete_prospect_failure( errors ) )
    })
  }
}

export {delete_prospect}



// WEBPACK FOOTER //
// ./src/js/actions/prospects/delete.js